<template>
  <div>
    <transition name="slide">
      <div v-show="visible" class="unlock-wrapper" :class="[`mq-${$mq}`]">
        <div class="close" @click="hideModal()">
          <base-svg svg="close" height="0.85rem" fill="white"/>
        </div>

        <div class="unlock-inner" :class="[`mq-${$mq}`]">
          <transition-group
            name="fade-slide-bottom"
            tag="div"
            v-if="reveal"
            class="reveal-group"
            appear
          >
            <div :key="'lottie'" class="animation">
              <Lottie ref="lottie" animation="reward" :relative="true" />
            </div>
            
            <h3 :key="'title-wrapper'">Unlock &ldquo;{{ stack.name }}&rdquo;</h3>
            <p :key="'byline-wrapper'">This stack will remain unlocked forever.</p>

            <button :key="'action'" @click="confirmUnlock()">Yep! Unlock &ldquo;{{ stack.name }}&rdquo;</button>
            <button :key="'action-ghost'" class="ghost" @click="hideModal()">I've changed my mind</button>
          </transition-group>
        </div>
      </div>
    </transition>
    <div v-if="visibleBackground" @click="hideModal()" class="background"></div>
  </div>
</template>

<script>
  import Lottie from '@/components/v5/Lottie.vue';
  import API from "app/axios.js";

  export default {
    data() {
      return {
        visible: false,
        visibleBackground: false,
        reveal: false,
        stack: {
          name: `UK Politics`,
        }
      }
    },

    components: {
      Lottie,
    },

    mounted () {
      this.play();

      this.EventBus.$on('modal:unlock-confirm', (stack) => {
        // Hide mobile navigation if expanded
        this.EventBus.$emit('header:hide');
        this.visibleBackground = true;
        this.visible = true;
        this.stack = stack;
        this.play();

        // Track when Unlock Stack modal is shown
        this.EventBus.$emit('track:event', {
          label: 'UnlockConform: Show',
          once: true, // default
        });
      });
    },

    computed: {
      getProfileImage() {
        return this.reason.invite_profile;
      }
    },

    methods: {
      hideModal() {
        this.visible = false;
        this.visibleBackground = false;
      },

      play() {
        this.reveal = true;

        setTimeout(() => {
          this.$refs.lottie?.play();
        }, 50);
      },

      confirmUnlock() {
        // Trigger logic to confirm unlocked stack and lock all other stacks
        API
          .patch(`/home/stack-manage/${this.stack.slug}`, {
            task: 'unlock'
          })
          .then(() => {
            // why not just go straight there?
            this.$userEngine.stackUnlock('off');
            this.$router.push(`/n/${this.stack.slug}`);
            this.hideModal();
            this.$userEngine.reload();
          })
          .catch((response) => {
            console.error(response);
          });
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .background {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    z-index: 9999999;
    background: rgba($neutral-100, 0.95);
  }

  // Mobile
  .unlock-wrapper {
    position: fixed;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999999;
    background: rgba($neutral-100, 1.0);
    color: $neutral-600;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);

    &.mq-md, &.mq-lg {
      top: 4rem;
      bottom: auto;
      max-width: 28rem;
      height: auto;
      border-radius: $border-radius;
    }

    .close {
      position: absolute;
      top: env(safe-area-inset-top);
      right: 0;
      padding: 1.5rem;
      z-index: 99;
      cursor: pointer;
      background: transparent;
    }

    .unlock-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 1.5rem 1.5rem 12rem 1.5rem;
      overflow-y: scroll;
      height: 100%;
      -ms-overflow-style: none;  // IE 10+
      overflow: -moz-scrollbars-none;  // Firefox
      &::-webkit-scrollbar {
        display: none; // Safari and Chrome
      }

      &.mq-md, &.mq-lg {
        padding: 4rem 2rem 4rem 2rem;
      }

      &.overflow-wrap {
        overflow: hidden;
      }

      .animation {
        margin-bottom: 2rem;
      }

      .profile-image {
        width: 8rem;
        height: 8rem;
        padding: 0.5rem;
        border-radius: 500px;
        border: 2px solid $yellow-tone-3;
        overflow: hidden;
        align-self: center;
        margin: 0 auto 2rem auto;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      h3 {
        margin-bottom: 0.5rem;
      }

      button {
        width: 100%;
        margin-top: 2rem;
      }
    }
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.15s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.30s;
  }
  .reveal-group > *:nth-child(5) {
    transition-delay: 0.40s;
  }
</style>

<style lang="scss">
.fade-slide-bottom-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-bottom-enter {
  opacity: 0;
  transform: translateY(50px);
}
.fade-slide-bottom-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>